import React from 'react'
import { useContext } from 'react';
import ThemeContext from '../../../../Context/theme/ThemeContext';
import { Link, Route, Routes, useLocation } from 'react-router-dom';
import ResolveTickets from './ResolveTickets';
import PendingTickets from './PendingTickets';
import TicketsChat from './TicketsChat';

const MainTicket = () => {
    const { theme } = useContext(ThemeContext);
    const location = useLocation();
  
    return (
      <div>
        <div
          className={` w-full px-2 md:px-6  ${theme == "dark" ? "bg-black text-white" : "bg-white text-gray-400"}`}
        >
          <div className="flex flex-row  font-pop items-center">
            <Link to={"/user-dashboard/ticket"}>
              <h2
                className={`px-2 md:px-8 py-2 md:py-4 text-sm md:text-base font-medium  border-b-4 ${
                  location.pathname == "/user-dashboard/ticket"
                    ? "border-primarygreen"
                    : "border-transparent"
                }`}
              >
                Pending
              </h2>
            </Link>
            <Link to={"/user-dashboard/ticket/resolved"}>
              <h2
                className={`px-2 md:px-8 py-2 md:py-4 text-sm md:text-base font-medium  border-b-4 ${
                  location.pathname == "/user-dashboard/ticket/resolved"
                    ? "border-primarygreen"
                    : "border-transparent"
                }`}
              >
                Resolved
              </h2>
            </Link>
          </div>
        </div>
        <div className="m-auto">
          <Routes>
            <Route path="/" element={<PendingTickets />} />
            <Route path="/resolved" element={<ResolveTickets />} />
            <Route path="/conversation/:caseid" element={<TicketsChat />} />
          </Routes>
        </div>
      </div>
    );
}

export default MainTicket